import { CivilCaseComplaint } from "types";
import apiClient from "../lib/apiClients";

// CIVIL CASE COMPLAINT
export const fetchCivilCaseComplaint = async () => {
  const response = await apiClient.get<CivilCaseComplaint[]>(
    "/complaint_handling/complaints/",
  );
  return response.data;
};
export const fetchCivilCaseComplaintByAdminAndOrg = async (
  admin_unit: string | number,
  org_unit: string | number,
) => {
  const response = await apiClient.get<CivilCaseComplaint[]>(
    `/complaint_handling/complaints/filter_by_units/?admin_unit_id=${admin_unit}&org_unit_id=${org_unit}`,
  );
  return response.data;
};
export const fetchCivilCaseComplaintForRegistrar = async (
  admin_unit: string | number,
) => {
  const response = await apiClient.get<CivilCaseComplaint[]>(
    `/complaint_handling/complaints/filter_by_admin_unit/?admin_unit_id=${admin_unit}`,
  );
  return response.data;
};
export const fetchCivilCaseComplaintById = async (id: number | string) => {
  const response = await apiClient.get<CivilCaseComplaint>(
    "/complaint_handling/complaints/" + id + "/",
  );
  return response.data;
};
export const addCivilCaseComplaint = async (complaint: CivilCaseComplaint) => {
  const response = await apiClient.post(
    "/complaint_handling/complaints/",
    complaint,
  );
  return response.data;
};
export const editCivilCaseComplaint = async (complaint: any) => {
  const response = await apiClient.patch(
    "/complaint_handling/complaints/" + complaint?.id + "/",
    complaint,
  );
  return response.data;
};
export const deleteCivilCaseComplaint = async (
  complaint: CivilCaseComplaint,
) => {
  const response = await apiClient.delete(
    "/complaint_handling/complaints/" + complaint?.id + "/",
  );
  return response.data;
};
export const fetchProsecutor = async (
  admin_id: string | number,
  org_id: string | number,
) => {
  const response = await apiClient.get<any[]>(
    `/complaint_handling/fetch-employees/?admin_id=${admin_id}&org_id=${org_id}/`,
  );
  return response.data;
};
